module.exports = __webpack_public_path__ + "img/index-section6-friend12.512ecb02.svg";